import DonutChartWidget from "./DonutChartWidget";
import React from "react";

interface CallsHandledByQueueWidgetData {
  queueName: string;
  totalHandledCalls: number;
}

const BASE_COLORS = [
  '#00FEC1', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FF6B6B', '#4ECDC4',
  '#FF9F1C', '#2EC4B6', '#E71D36', '#011627', '#7B2CBF', '#3A0CA3', '#4361EE', '#4CC9F0',
  '#F72585', '#7209B7', '#3A0CA3', '#4361EE', '#4CC9F0', '#4895EF', '#560BAD', '#480CA8',
  '#3F37C9', '#4CC9F0', '#F72585', '#B5179E', '#7209B7', '#3A0CA3', '#4361EE', '#4895EF'
];
const LIGHT_COLORS = ["#23407a", ...BASE_COLORS];
const DARK_COLORS = ['#1681F6', ...BASE_COLORS];

interface CallsHandledByQueueWidgetProps {
  data: CallsHandledByQueueWidgetData[];
  loading?: boolean;
  error?: string | null;
}

const CallsHandledByQueueWidget: React.FC<CallsHandledByQueueWidgetProps> = ({ data, loading, error }) => {
  const donutData = (data ?? [])
    .filter(item => item.totalHandledCalls > 0)
    .map(item => ({ name: item.queueName, value: item.totalHandledCalls }));

  return (
    <DonutChartWidget
      title="Inbound Handled By Call Queue"
      tooltipDescription="The percentage of total number of inbound calls distributed to each Call Queue within the given time."
      data={donutData}
      colors={LIGHT_COLORS}
      darkColors={DARK_COLORS}
      loading={loading}
      error={error}
      legendVerticalAlign="middle"
      legendScrollable
      legendTruncateAt={15}
    />
  );
};

export default CallsHandledByQueueWidget;
